import classNames from 'classnames';
import { ReactNode } from 'react';
import './index.scss';

interface CardProps {
  id?: string | number;
  title: string;
  children: ReactNode;
  status?: 'primary' | 'light';
  type?: 'default' | 'outlined';
  floatRight?: ReactNode;
  customClass?: string;
  onClick?: () => void;
}

export const Card = ({
  id,
  onClick,
  title,
  children,
  type = 'default',
  status = 'primary',
  floatRight,
  customClass
}: CardProps) => {
  return (
    <div
      id={String(id)}
      className={classNames('ui-card', customClass,  {
        [type]: true,
        [`status--${status}`]: true,
      })}
      onClick={onClick}>
      <div className='ui-card__main-content'>
        <div className='font-heading text-heading-xs mb-2'>{title}</div>
        {children}
      </div>

      {floatRight && <div className='ui-card__side-action'>{floatRight}</div>}
    </div>
  );
};
